<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">{{ key ? 'Editar' : 'Novo' }} Texto Legal</h1>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow p-6">
    <form [formGroup]="form" (ngSubmit)="save()" class="space-y-6">
      <!-- Title -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Título</label>
        <input
          type="text"
          formControlName="title"
          placeholder="Ex: Termos de Uso"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
        />
        <p *ngIf="form.get('title')?.hasError('required') && form.get('title')?.touched" class="text-red-600 text-sm mt-1">
          Título é obrigatório
        </p>
        <p *ngIf="form.get('title')?.hasError('minlength') && form.get('title')?.touched" class="text-red-600 text-sm mt-1">
          Título deve ter pelo menos 3 caracteres
        </p>
      </div>

      <!-- Content HTML -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Conteúdo (HTML)</label>
        <textarea
          formControlName="contentHtml"
          placeholder="Cole aqui o conteúdo HTML..."
          rows="10"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500 font-mono text-sm"
        ></textarea>
        <p *ngIf="form.get('contentHtml')?.hasError('required') && form.get('contentHtml')?.touched" class="text-red-600 text-sm mt-1">
          Conteúdo é obrigatório
        </p>
        <p *ngIf="form.get('contentHtml')?.hasError('minlength') && form.get('contentHtml')?.touched" class="text-red-600 text-sm mt-1">
          Conteúdo deve ter pelo menos 10 caracteres
        </p>
      </div>

      <!-- Version (Optional) -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Versão (Opcional)</label>
        <input
          type="text"
          formControlName="version"
          placeholder="Ex: 1.0"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500"
        />
      </div>

      <!-- Actions -->
      <div class="flex gap-3 pt-4 border-t">
        <button
          type="submit"
          [disabled]="form.invalid || saving"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ saving ? 'Salvando...' : 'Salvar' }}
        </button>
        <button
          type="button"
          (click)="cancel()"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
        >
          Cancelar
        </button>
      </div>
    </form>
  </div>
</div>
